<template>
  <customDialog
    customWidth="80%"
    v-if="show"
    :title="isEdit ? $t('EDIT') : $t('SUBMIT')"
    childClass="info_msg"
    :show="show"
    @show="$emit('update:show', $event)"
    form="true"
    @confirmButn="submitTransaction"
  >
    <el-tabs
      v-model="activeTab"
      class="mb-4"
      type="card"
      @tab-click="handleTabChange"
    >
      <el-tab-pane
        v-if="!formType || formType === 'fullForm'"
        label="سوخت‌گیری"
        name="fullForm"
      ></el-tab-pane>
      <el-tab-pane
        v-if="!formType || formType === 'simpleForm'"
        label="سهمیه سوخت"
        name="simpleForm"
      ></el-tab-pane>
    </el-tabs>

    <el-form
      v-if="currentFormType === 'fullForm'"
      status-icon
      :model="transactionForm"
      label-position="top"
      ref="transactionForm"
      label-width="120px"
      :rules="transactionRules"
      class="demo-ruleForm grid lg:grid-cols-3 gap-4 status-icon"
    >
      <el-form-item
        :label="$t('TYPE')"
        prop="typeTransaction"
        :rules="{
          required: true,
          message: $t('REQUIRED_CHOOSE', {
            type: $t('TYPE'),
          }),
          trigger: 'blur',
        }"
      >
        <el-select
          v-model="transactionForm.typeTransaction"
          :placeholder="$t('SELECT_PLACEHOLDER')"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <VehicleSelect
        v-if="transactionForm.typeTransaction == 0"
        prop="company_vehicle"
        label="used_quota_vehicle"
        :model="transactionForm.used_quota"
        @update="transactionForm.used_quota = $event"
        :disabled="transactionForm.typeTransaction === 1"
      />

      <el-form-item
        :label="$t('FUEL_TYPE')"
        prop="fuel_type.id"
        v-loading="fuelsTypeLoading"
        :rules="{
          required: true,
          message: $t('REQUIRED_CHOOSE', {
            type: $t('FUEL_TYPE'),
          }),
          trigger: 'blur',
        }"
      >
        <el-select
          :placeholder="$t('SELECT_PLACEHOLDER')"
          clearable
          filterable
          v-model="transactionForm.fuel_type.id"
        >
          <el-option
            v-for="item in fuelsType"
            :key="item.id"
            :label="item.fa_title"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        :label="$t('amount')"
        prop="amount"
        :rules="{
          required: true,
          message: $t('REQUIRED_FIELD', {
            type: $t('amount'),
          }),
          trigger: 'blur',
        }"
      >
        <el-input
          type="text"
          v-model="transactionForm.amount"
          @input="
            transactionForm.amount = currency(
              toEnglish(transactionForm.amount, false)
            )
          "
          @blur="calculateTotalPaid()"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <PriceInput
        label="price_per_liter"
        prop="price_per_liter"
        :model="transactionForm.price_per_liter"
        @update="transactionForm.price_per_liter = $event"
        @blur="calculateTotalPaid()"
        style="margin-bottom: 40px"
      />
      <PriceInput
        label="total_paid"
        prop="total_paid"
        :model="transactionForm.total_paid"
        @update="transactionForm.total_paid = $event"
        @blur="calculatePricePerLiter()"
        style="margin-bottom: 40px"
      />

      <el-form-item
        :label="$t('DATE')"
        prop="date"
        :rules="{
          required: true,
          message: $t('REQUIRED_FIELD', {
            type: $t('DATE'),
          }),
          trigger: 'blur',
        }"
      >
        <date-picker
          color="#151515"
          class="el-input__inner"
          v-model="transactionForm.date"
          format="jYYYY-jMM-jDD"
          clearable
          :max="maxDate"
          :locale="$i18n.locale"
        />
      </el-form-item>

      <el-form-item
        :label="$t('FUEL_ODOMOTER')"
        prop="odometer"
        :rules="{
          required: true,
          message: $t('REQUIRED_FIELD', {
            type: $t('FUEL_ODOMOTER'),
          }),
          trigger: 'blur',
        }"
      >
        <el-input
          type="text"
          v-model="transactionForm.odometer"
          @input="
            transactionForm.odometer = currency(
              toEnglish(transactionForm.odometer, false)
            )
          "
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item
        :label="$t('DRIVER_TITLE')"
        prop="driver.id"
        v-loading="driversListLoading"
        element-loading-spinner="el-icon-loading"
      >
        <el-select
          v-model="transactionForm.driver.id"
          clearable
          filterable
          :placeholder="$t('SELECT_PLACEHOLDER')"
        >
          <el-option
            v-for="item in driversList"
            :key="item.id"
            :label="item.first_name + ' ' + item.last_name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        class="col-span-full"
        :label="$t('description')"
        prop="description"
      >
        <el-input
          :disabled="transactionForm.disabled"
          type="textarea"
          v-model="transactionForm.description"
        ></el-input>
      </el-form-item>
    </el-form>

    <!-- Simple Form -->
    <el-form
      v-else-if="currentFormType === 'simpleForm'"
      status-icon
      :model="simpleForm"
      label-position="top"
      ref="simpleForm"
      :rules="simpleFormRules"
      label-width="120px"
      class="demo-ruleForm grid grid-cols-2 gap-4 status-icon"
    >
      <el-form-item
        :label="$t('DATE_')"
        prop="date"
        :rules="{
          required: true,
          message: $t('REQUIRED_FIELD', {
            type: $t('DATE_'),
          }),
          trigger: 'blur',
        }"
      >
        <date-picker
          color="#151515"
          class="el-input__inner"
          v-model="simpleForm.date"
          format="jYYYY-jMM-jDD"
          clearable
          :max="maxDate"
          :locale="$i18n.locale"
        />
      </el-form-item>

      <el-form-item
        :label="$t('amount')"
        prop="amount"
        :rules="{
          required: true,
          message: $t('REQUIRED_FIELD', {
            type: $t('amount'),
          }),
          trigger: 'blur',
        }"
      >
        <el-input
          type="text"
          v-model="simpleForm.amount"
          @input="
            simpleForm.amount = currency(toEnglish(simpleForm.amount, false))
          "
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item
        :label="$t('FUEL_TYPE')"
        prop="fuel_type"
        v-loading="fuelsTypeLoading"
        :rules="{
          required: true,
          message: $t('REQUIRED_CHOOSE', {
            type: $t('FUEL_TYPE'),
          }),
          trigger: 'blur',
        }"
      >
        <el-select
          :placeholder="$t('SELECT_PLACEHOLDER')"
          clearable
          filterable
          v-model="simpleForm.fuel_type"
        >
          <el-option
            v-for="item in fuelsType"
            :key="item.id"
            :label="item.fa_title"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <VehicleSelect
        prop="company_vehicle"
        :model="simpleForm.company_vehicle"
        @update="simpleForm.company_vehicle = $event"
      />

      <el-form-item
        class="col-span-full"
        :label="$t('description')"
        prop="description"
      >
        <el-input
          :disabled="simpleForm.disabled"
          type="textarea"
          v-model="simpleForm.description"
        ></el-input>
      </el-form-item>
    </el-form>

    <template v-slot:footerConfirm>
      <el-button type="success" @click="submitTransaction">
        {{ $t("SUBMIT") }}
      </el-button>
    </template>
  </customDialog>
</template>

<script>
import {
  fuelType_,
  addTransaction,
  editTransaction,
  addFuelQuotas,
  editFuelQuotas,
} from "@/api/fuel";
import customDialog from "@/components/elements/dialog";
import VehicleSelect from "@/components/elements/vehiclesSelect";
import { toEnglish } from "@/mixins/toEnglish";
import { resetForm } from "@/mixins/resetForm";
import { jalaliToGregorian } from "@/mixins/jalaliToGregorian";
import { gregorianToJalali } from "@/mixins/gregorianToJalali";
import { driverSummary } from "@/api/drivers";
import { currency } from "@/mixins/currency";
import { reverseCurrency } from "@/mixins/reverseCurrency";
import PriceInput from "@/components/elements/priceInput.vue";

export default {
  name: "FuelTransactionForm",
  mixins: [
    toEnglish,
    resetForm,
    jalaliToGregorian,
    gregorianToJalali,
    currency,
    reverseCurrency,
  ],
  props: {
    formType: {
      type: String,
      default: null,
      validator: (value) => {
        return !value || ["fullForm", "simpleForm"].includes(value);
      },
    },
    show: {
      type: Boolean,
      default: false,
    },
    transaction: {
      type: Object,
      default: () => ({}),
    },
    selectedVehicle: {
      type: [String, Number],
      default: null,
    },
    selectedDriver: {
      type: [String, Number],
      default: null,
    },
    currentOdometer: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      activeTab: "fullForm",
      simpleForm: {
        date: "",
        amount: "",
        fuel_type: "",
        company_vehicle: "",
        description: "",
      },
      transactionForm: {
        typeTransaction: 0,
        company_vehicle: "",
        used_quota: null,
        odometer: "",
        date: "",
        amount: "",
        price_per_liter: "",
        total_paid: "",
        fuel_type: {
          id: "",
        },
        description: "",
        driver: {
          id: "",
        },
        id: null,
      },
      fuelsType: [],
      fuelsTypeLoading: false,
      driversList: [],
      driversListLoading: false,
      submitLoading: false,
      options: [
        {
          value: 0,
          label: "سهمیه ای",
        },
        {
          value: 1,
          label: "آزاد",
        },
      ],
      transactionRules: {
        company_vehicle: [
          {
            required: true,
            message: this.$i18n.t("REQUIRED_CHOOSE", {
              type: this.$i18n.t("VEHICLE_TITLE"),
            }),
            trigger: "blur",
          },
        ],
      },
      simpleFormRules: {
        company_vehicle: [
          {
            required: true,
            message: this.$i18n.t("REQUIRED_CHOOSE", {
              type: this.$i18n.t("VEHICLE_TITLE"),
            }),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.transactionForm.id;
    },
    currentFormType() {
      return this.formType || this.activeTab;
    },
    maxDate() {
      let todayDate = new Date()
        .toLocaleDateString("en-us")
        .replaceAll("/", "-")
        .split("-");
      todayDate = `${todayDate[2]}-${todayDate[0]}-${todayDate[1]}`;
      return this.gregorianToJalali(todayDate, "fa");
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.loadData();
        if (this.currentOdometer) {
          this.transactionForm.odometer = this.currency(
            this.currentOdometer / 1000
          );
        }
      } else {
        this.resetTransactionForm();
        this.resetSimpleForm();
      }
    },
    formType: {
      handler(newFormType) {
        if (newFormType) {
          this.activeTab = newFormType;
        }
      },
      immediate: true,
    },
    transaction: {
      handler(newTransaction) {
        if (Object.keys(newTransaction).length > 0) {
          this.transactionForm = JSON.parse(JSON.stringify(newTransaction));
          if (
            this.currentFormType === "simpleForm" ||
            this.formType === "simpleForm"
          ) {
            this.simpleForm = {
              date: newTransaction.date || "",
              amount: newTransaction.amount || 0,
              fuel_type:
                newTransaction.fuel_type?.id || newTransaction.fuel_type || "",
              company_vehicle: newTransaction.company_vehicle || "",
              id: newTransaction.id || null,
              description: newTransaction.description || null,
            };
          }
        }
      },
      immediate: true,
      deep: true,
    },
    selectedVehicle: {
      handler(newVal) {
        if (newVal && !this.transactionForm.company_vehicle) {
          this.transactionForm.company_vehicle = newVal;
          this.transactionForm.used_quota = newVal;
        }
        if (!this.simpleForm.company_vehicle) {
          this.simpleForm.company_vehicle = newVal;
        }
      },
      immediate: true,
    },
    currentOdometer: {
      handler(newVal) {
        if (
          newVal &&
          (!this.transactionForm.odometer ||
            this.transactionForm.odometer === "")
        ) {
          this.transactionForm.odometer = this.currency(newVal / 1000);
        }
      },
      immediate: true,
      deep: true,
    },
    selectedDriver: {
      handler(newVal) {
        if (newVal && !this.transactionForm.driver.id) {
          this.transactionForm.driver.id = newVal;
        }
      },
      immediate: true,
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    handleTabChange() {
      this.$nextTick(() => {
        if (this.activeTab === "fullForm" && this.$refs.transactionForm) {
          this.$refs.transactionForm.clearValidate();
        } else if (this.activeTab === "simpleForm" && this.$refs.simpleForm) {
          this.$refs.simpleForm.clearValidate();
        }
      });
    },
    calculatePricePerLiter() {
      if (
        this.transactionForm.amount &&
        this.transactionForm.total_paid &&
        (!this.transactionForm.price_per_liter ||
          this.transactionForm.price_per_liter === "")
      ) {
        const amount = +this.reverseCurrency(this.transactionForm.amount);
        const totalPaid = +this.reverseCurrency(
          this.transactionForm.total_paid
        );

        if (amount > 0) {
          const pricePerLiter = totalPaid / amount;
          const formattedPrice = parseFloat(pricePerLiter.toFixed(1));
          this.transactionForm.price_per_liter = this.currency(
            formattedPrice.toString()
          );
          this.$nextTick(() => {
            if (this.$refs.transactionForm) {
              this.$refs.transactionForm.validateField("price_per_liter");
            }
          });
        }
      }
    },
    calculateTotalPaid() {
      if (
        this.transactionForm.amount != "" &&
        this.transactionForm.price_per_liter &&
        !this.transactionForm.total_paid
      ) {
        const amount = +this.reverseCurrency(this.transactionForm.amount);
        const pricePerLiter = +this.reverseCurrency(
          this.transactionForm.price_per_liter
        );
        const total = amount * pricePerLiter;
        this.transactionForm.total_paid = this.currency(total.toString());
        this.$nextTick(() => {
          if (this.$refs.transactionForm) {
            this.$refs.transactionForm.validateField("total_paid");
          }
        });
      } else {
      }
    },
    loadData() {
      this.fuelsTypeLoading = true;
      fuelType_.api().then((res) => {
        if (res) {
          this.fuelsType = res;
          this.fuelsTypeLoading = false;
        }
      });

      // Load drivers list
      this.driversListLoading = true;
      driverSummary.api().then((res) => {
        if (res) {
          this.driversList = res;
          this.driversListLoading = false;
        }
      });
    },
    resetSimpleForm() {
      this.simpleForm = {
        date: "",
        amount: 0,
        fuel_type: "",
        company_vehicle: this.selectedVehicle || "",
        description: "",
      };
    },

    resetTransactionForm() {
      this.transactionForm = {
        typeTransaction: 0,
        company_vehicle: this.selectedVehicle || "",
        used_quota: this.selectedVehicle || null,
        odometer: this.currency(this.currentOdometer / 1000) || null,
        date: "",
        amount: "",
        price_per_liter: "",
        total_paid: "",
        fuel_type: {
          id: "",
        },
        description: "",
        driver: {
          id: this.selectedDriver || "",
        },
        id: null,
      };
    },

    submitTransaction() {
      const isSimpleForm = this.activeTab === "simpleForm";
      const formRef = isSimpleForm ? "simpleForm" : "transactionForm";

      this.$refs[formRef].validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          let actionPayload;
          let isUpdate = false; // Define isUpdate here at a higher scope

          if (isSimpleForm) {
            // Handle simple form submission
            actionPayload = {
              date: this.jalaliToGregorian(
                this.simpleForm.date,
                this.$i18n.locale
              ),
              amount: +this.reverseCurrency(this.simpleForm.amount),
              fuel_type: this.simpleForm.fuel_type,
              company_vehicle: this.simpleForm.company_vehicle,
              description: this.simpleForm.description,
            };

            // Set isUpdate for simple form
            const simpleFormId = this.transaction?.id;
            isUpdate = !!simpleFormId;
          } else {
            // Handle full form submission
            actionPayload = {
              amount: +this.reverseCurrency(this.transactionForm.amount),
              price_per_liter: +this.reverseCurrency(
                this.transactionForm.price_per_liter
              ),
              total_paid: +this.reverseCurrency(
                this.transactionForm.total_paid
              ),
              date: this.jalaliToGregorian(
                this.transactionForm.date,
                this.$i18n.locale
              ),
              fuel_type: this.transactionForm.fuel_type.id,
              company_vehicle: this.transactionForm.company_vehicle,
              used_quota:
                this.transactionForm.typeTransaction === 0
                  ? this.transactionForm.used_quota
                  : null,
              odometer:
                +this.reverseCurrency(this.transactionForm.odometer) * 1000,
              driver: this.transactionForm.driver.id,
              description: this.transactionForm.description || "",
            };

            // Set isUpdate for full form
            isUpdate = !!this.transactionForm.id;
          }

          let apiMethod;

          if (isSimpleForm) {
            // Simple form uses different API endpoints
            apiMethod = isUpdate
              ? editFuelQuotas.api({
                  ...actionPayload,
                  id: this.transaction.id,
                })
              : addFuelQuotas.api(actionPayload);
          } else {
            // Full form uses regular transaction endpoints
            apiMethod = isUpdate
              ? editTransaction.api({
                  ...actionPayload,
                  id: this.transactionForm.id,
                })
              : addTransaction.api(actionPayload);
          }

          apiMethod
            .then((res) => {
              this.submitLoading = false;
              if (res) {
                this.$emit("update:show", isUpdate ? false : true);

                if (!isUpdate) {
                  this.resetTransactionForm();
                  this.resetSimpleForm();
                }

                // Emit event with the data for the parent to handle
                this.$emit(
                  isUpdate ? "transaction-updated" : "transaction-added",
                  res
                );

                this.$notify.success({
                  title:
                    this.$t(isUpdate ? "EDIT" : "SUBMIT") +
                    " " +
                    this.$t("SUCCESSFULLY_DONE"),
                  duration: 5000,
                  customClass: "succ_msg",
                });
              }
            })
            .catch((error) => {
              this.submitLoading = false;
              this.$notify.error({
                title: this.$i18n.t("ERROR"),
                message: error.message || this.$i18n.t("SOMETHING_WENT_WRONG"),
                duration: 5000,
                customClass: "error_msg",
              });
            });
        } else {
          this.$notify.error({
            title: this.$i18n.t("FIXED_ERRORS", {
              type: this.$i18n.t("fuel_transaction"),
            }),
            duration: 5000,
            customClass: "error_msg",
          });
          return false;
        }
      });
    },
  },
  components: {
    customDialog,
    VehicleSelect,
    PriceInput,
  },
};
</script>
